/* Family Legacy Tree — name layout + preview drawing.
   Coordinates are in the 3000 x 2000 master space. The layout this produces is sent with the order,
   and the print renderer (compose.py) draws exactly the same frames and names from it. */
(function (root) {
  'use strict';
  var W = 3000, H = 2000, TRACK = 0.14;
  var FONT = { kid: ['700', 42, 'Cormorant'], couple: ['700', 39, 'Cormorant'], gp: ['700', 60, 'Cormorant'],
               root: ['700', 34, 'Cormorant'], years: ['italic 400', 27, 'EB Garamond'],
               amp: ['italic 400', 64, 'EB Garamond'], ampS: ['italic 400', 46, 'EB Garamond'],
               small: ['italic 400', 36, 'EB Garamond'], title: ['400', 132, 'Pinyon Script'] };

  function mulberry32(a) {
    return function () {
      a |= 0; a = a + 0x6D2B79F5 | 0;
      var t = Math.imul(a ^ a >>> 15, 1 | a);
      t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
      return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
  }
  function pct(arr, p) {               // numpy-style linear percentile
    var a = arr.slice().sort(function (x, y) { return x - y; });
    var k = (a.length - 1) * p / 100, f = Math.floor(k), c = Math.min(f + 1, a.length - 1);
    return a[f] + (a[c] - a[f]) * (k - f);
  }

  // ---------- text measuring ----------
  var mctx = null;
  function ctxFor() {
    if (!mctx) { var c = document.createElement('canvas'); mctx = c.getContext('2d'); }
    return mctx;
  }
  function fontStr(key, scale) { var f = FONT[key]; return f[0] + ' ' + (f[1] * (scale || 1)) + 'px "' + f[2] + '"'; }
  function textW(s, key, scale) { var c = ctxFor(); c.font = fontStr(key, scale); return c.measureText(s).width; }
  function capsLen(s, key, scale) {
    var c = ctxFor(); c.font = fontStr(key, scale); var w = 0;
    for (var i = 0; i < s.length; i++) w += c.measureText(s[i]).width;
    return w + TRACK * FONT[key][1] * (scale || 1) * (s.length - 1);
  }

  // ---------- tree data ----------
  function Tree(data, bodyImg) {
    this.fx = data.fx; this.fy = data.fy; this.base_y = data.base_y;
    // deep-roots tree: a smaller crown (k), its own trunk-label spot and size (gp), and fixed spots for the root names
    this.deep = data.kind === 'deep'; this.v = data.v || 1; this.rf = data.rf; this.k = data.k || 1; this.gp = data.gp || { x: W / 2, y: 1300, s: 1 }; this.spots = data.spots || [];
    var n = data.nodes.length;
    this.X = new Float32Array(n); this.Y = new Float32Array(n); this.R = new Float32Array(n); this.LC = new Int32Array(n);
    this.crown = new Uint8Array(n);
    for (var i = 0; i < n; i++) {
      var d = data.nodes[i]; this.X[i] = d[0]; this.Y[i] = d[1]; this.R[i] = d[2]; this.LC[i] = d[3];
      this.crown[i] = d[1] < this.fy - 40 ? 1 : 0;
    }
    this.n = n;
    // integral image of the trunk/limb mask (quarter resolution)
    var bw = bodyImg.width, bh = bodyImg.height;
    var c = document.createElement('canvas'); c.width = bw; c.height = bh;
    var g = c.getContext('2d'); g.drawImage(bodyImg, 0, 0);
    var px = g.getImageData(0, 0, bw, bh).data;
    var I = new Float64Array((bw + 1) * (bh + 1));
    for (var y = 0; y < bh; y++) {
      var row = 0;
      for (var x = 0; x < bw; x++) {
        row += px[(y * bw + x) * 4] / 255;
        I[(y + 1) * (bw + 1) + x + 1] = I[y * (bw + 1) + x + 1] + row;
      }
    }
    this.I = I; this.bw = bw; this.bh = bh;
    var cx = [], cy = [];
    for (i = 0; i < n; i++) if (this.crown[i]) { cx.push(this.X[i]); cy.push(this.Y[i]); }
    this.xl = pct(cx, 4); this.xr = pct(cx, 96); this.ytop = pct(cy, 3) + 50;
  }
  Tree.prototype.bodyMean = function (b) {
    var x0 = Math.max(0, Math.floor(b[0] / 4)), y0 = Math.max(0, Math.floor(b[1] / 4));
    var x1 = Math.min(this.bw, Math.floor(b[2] / 4)), y1 = Math.min(this.bh, Math.floor(b[3] / 4));
    if (x1 <= x0 || y1 <= y0) return 0;
    var W1 = this.bw + 1, I = this.I;
    var s = I[y1 * W1 + x1] - I[y0 * W1 + x1] - I[y1 * W1 + x0] + I[y0 * W1 + x0];
    return s / ((x1 - x0) * (y1 - y0));
  };

  // ---------- layout ----------
  function splitCouple(c) {
    if (c.indexOf('&') >= 0) { var p = c.split('&'); return [p[0].trim(), p.slice(1).join('&').trim()]; }
    return [c.trim(), ''];
  }
  function layoutAt(order, T, s) {
    var fams = order.children, nf = fams.length, boxes = [], carts = [], missing = [], blankMissing = [];
    var rnd = mulberry32(12345);
    function overlap(a, b) { var p = 20; return !(a[2] + p < b[0] || b[2] + p < a[0] || a[3] + p < b[1] || b[3] + p < a[1]); }
    var maxBody = 0.05;
    function free(b) {
      if (!(b[0] > 70 && b[2] < W - 70 && b[1] > 300)) return false;
      for (var i = 0; i < boxes.length; i++) if (overlap(b, boxes[i])) return false;
      return T.bodyMean(b) < maxBody;
    }
    var gp1 = (order.grandpa || '').toUpperCase(), gp2 = (order.grandma || '').toUpperCase();
    var gS = T.gp.s, TK = T.k;   // 1 and 1 on the classic tree
    var gpw = capsLen(gp1, 'gp', gS) + capsLen(gp2, 'gp', gS) + 130 * gS;
    var GP = [T.gp.x, T.gp.y, gpw / 2 + 80 * gS, 96 * gS];
    boxes.push([GP[0] - GP[2], GP[1] - GP[3], GP[0] + GP[2], GP[1] + GP[3]]);
    carts.push({ kind: 'gp', x: GP[0], y: GP[1], hw: GP[2], hh: GP[3], a: gp1, b: gp2, year: order.year || '' });
    var KH = 40 * s, CHH = 46 * s;
    // a blank leaf (empty name) is as wide as a 7-letter name, room to write one in later with a paint pen
    function kidHW(nm) { return capsLen((nm || 'MADISON').toUpperCase(), 'kid', s) / 2 + 46 * s; }
    var wts = fams.map(function (f) { return Math.max(f.kids.length + Math.min(3, f.blank | 0), 1.5) + 1; });
    var tot = wts.reduce(function (a, b) { return a + b; }, 0), acc = 0, xb = [T.xl];
    for (var k = 0; k < nf; k++) { acc += wts[k]; xb.push(T.xl + (T.xr - T.xl) * acc / tot); }
    var X = T.X, Y = T.Y, R = T.R, LC = T.LC, crown = T.crown, n = T.n, fy = T.fy;
    for (k = 0; k < nf; k++) {
      var f = fams[k], b0 = xb[k], b1 = xb[k + 1], mid = (b0 + b1) / 2, bw = b1 - b0;
      var cp = splitCouple(f.couple || '');
      var cw = capsLen((cp[0] + ' ' + cp[1]).toUpperCase(), 'couple', s) / 2 + 84 * s;
      var cand = [];
      for (var i = 0; i < n; i++) if (crown[i] && X[i] > b0 + 0.1 * bw && X[i] < b1 - 0.1 * bw && Y[i] > fy - 520 * TK && R[i] > 0.03) cand.push(i);
      var ty = fy - (290 - 60 * (k % 2)) * TK;
      cand.sort(function (a, b) { return (Math.abs(X[a] - mid) + Math.abs(Y[a] - ty) * 0.8) - (Math.abs(X[b] - mid) + Math.abs(Y[b] - ty) * 0.8); });
      var placed = -1; maxBody = 0.12;
      for (var c = 0; c < Math.min(900, cand.length); c++) {
        i = cand[c]; var bx = [X[i] - cw, Y[i] - CHH, X[i] + cw, Y[i] + CHH];
        if (free(bx)) { placed = i; boxes.push(bx); break; }
      }
      maxBody = 0.05;
      if (placed < 0) { missing.push(f.couple || ('Branch ' + (k + 1))); f.kids.forEach(function (x) { missing.push(x); }); continue; }
      carts.push({ kind: 'couple', fam: k, x: X[placed], y: Y[placed], hw: cw, hh: CHH, a: cp[0].toUpperCase(), b: cp[1].toUpperCase() });
      var cy = Y[placed], names = f.kids, sel = [];
      var hw = names.length ? Math.max.apply(null, names.map(kidHW)) : 0;
      for (var relax = 0; relax < 3 && sel.length < names.length; relax++) {
        maxBody = [0.05, 0.12, 0.3][relax];
        var mm = [0.06, 0.0, -0.08][relax], gapY = [100, 85, 70][relax] * TK, lcMax = [12, 60, 1000][relax];
        cand = [];
        for (i = 0; i < n; i++) if (crown[i] && X[i] > b0 + mm * bw && X[i] < b1 - mm * bw && Y[i] > T.ytop && Y[i] < cy - gapY && LC[i] <= lcMax) cand.push(i);
        for (i = cand.length - 1; i > 0; i--) { var j = Math.floor(rnd() * (i + 1)); var tmp = cand[i]; cand[i] = cand[j]; cand[j] = tmp; }
        while (sel.length < names.length && cand.length) {
          var best = -1, bd = -1e9;
          for (c = 0; c < Math.min(700, cand.length); c++) {
            i = cand[c]; var bb = [X[i] - hw, Y[i] - KH, X[i] + hw, Y[i] + KH];
            if (!free(bb)) continue;
            var md = 400 * TK;
            if (sel.length) { md = 1e9; for (var q = 0; q < sel.length; q++) md = Math.min(md, Math.hypot(X[i] - X[sel[q]], (Y[i] - Y[sel[q]]) * 1.5)); }
            var score = Math.min(md, 330 * TK) - 0.35 * Math.abs(X[i] - mid);
            if (score > bd) { best = i; bd = score; }
          }
          if (best < 0) break;
          sel.push(best); boxes.push([X[best] - hw, Y[best] - KH, X[best] + hw, Y[best] + KH]);
          cand.splice(cand.indexOf(best), 1);
        }
      }
      maxBody = 0.05;
      for (i = sel.length; i < names.length; i++) missing.push(names[i]);
      sel.sort(function (a, b) { var ra = Math.round(Y[a] / (110 * TK)), rb = Math.round(Y[b] / (110 * TK)); return ra !== rb ? ra - rb : X[a] - X[b]; });
      for (i = 0; i < sel.length; i++) carts.push({ kind: 'kid', fam: k, x: X[sel[i]], y: Y[sel[i]], hw: kidHW(names[i]), hh: KH, a: names[i].toUpperCase() });
      // blank leaves (empty name spaces for future grandchildren): only on open leafy spots in this branch's band, never
      // over thick wood, where an empty oval would look washed out
      var nb = Math.max(0, Math.min(3, f.blank | 0)), bhw = kidHW(''), bsel = [];
      for (var bt = 0; bt < 3 && bsel.length < nb; bt++) {
        maxBody = [0.03, 0.06, 0.1][bt];
        var bm = [0, -0.1, -0.2][bt], ylo = [cy - 85 * TK, cy - 40 * TK, cy + 120 * TK][bt];
        cand = [];
        for (i = 0; i < n; i++) if (crown[i] && X[i] > b0 + bm * bw && X[i] < b1 - bm * bw && Y[i] > T.ytop && Y[i] < ylo && LC[i] <= 60) cand.push(i);
        for (i = cand.length - 1; i > 0; i--) { j = Math.floor(rnd() * (i + 1)); tmp = cand[i]; cand[i] = cand[j]; cand[j] = tmp; }
        var near = sel.concat([placed]);
        while (bsel.length < nb && cand.length) {
          best = -1; bd = -1e9;
          for (c = 0; c < Math.min(900, cand.length); c++) {
            i = cand[c]; bb = [X[i] - bhw, Y[i] - KH, X[i] + bhw, Y[i] + KH];
            if (!free(bb)) continue;
            md = 1e9; near.concat(bsel).forEach(function (q) { md = Math.min(md, Math.hypot(X[i] - X[q], (Y[i] - Y[q]) * 1.5)); });
            score = Math.min(md, 330 * TK) - 0.35 * Math.abs(X[i] - mid);
            if (score > bd) { best = i; bd = score; }
          }
          if (best < 0) break;
          bsel.push(best); boxes.push([X[best] - bhw, Y[best] - KH, X[best] + bhw, Y[best] + KH]);
          cand.splice(cand.indexOf(best), 1);
        }
      }
      maxBody = 0.05;
      for (i = bsel.length; i < nb; i++) blankMissing.push(f.couple || 'branch ' + (k + 1));
      bsel.forEach(function (q) { carts.push({ kind: 'kid', fam: k, x: X[q], y: Y[q], hw: bhw, hh: KH, a: '', blank: true }); });
    }
    // ancestors on the roots
    var lenses = [], by = T.base_y, deep = !!(T.deep && order.deep), RF = T.rf || 0.86;
    if (deep) {
      // order.deep: [left inner, left outer, right inner, right outer], each {name, years, couple, surname, cyears}
      T.spots.forEach(function (sp) {
        var inner = sp.side < 0 ? sp.who === 1 : sp.who === 2, e = order.deep[(sp.side < 0 ? 0 : 2) + (inner ? 0 : 1)] || {}, nm, yr;
        if (sp.tier === 1) { nm = (e.name || '').trim(); yr = (e.years || '').trim(); }
        else { var cp = (e.couple || '').trim(), sn = (e.surname || '').trim(); nm = cp ? cp + (sn ? ' ' + sn : '') : ''; yr = (e.cyears || '').trim(); }
        if (!nm) return;
        nm = nm.toUpperCase();
        var tl = T.v >= 3 ? Math.max(-0.04, Math.min(0.04, sp.tilt)) : sp.tilt;   // nearly level, so the (level) name stays inside
        lenses.push({ side: sp.side, k: inner ? 0 : 1, tier: sp.tier, cx: sp.cx, cy: sp.cy, tilt: tl, name: nm, years: yr, last: false,
                      hw: Math.max(capsLen(nm, 'root', RF), yr ? textW(yr, 'years', RF) : 0) / 2 + 84, hh: (yr ? 50 : 38) * RF });
      });
      if (T.v >= 3) {
        // keep a gap between boxes on each side: inner names stay on their spot, outer ones move outward along their root
        var GAP = 30;
        var ext = function (l) { var c = Math.cos(l.tilt), sn = Math.abs(Math.sin(l.tilt)); return [l.hw * c + l.hh * sn, l.hw * sn + l.hh * c]; };
        [-1, 1].forEach(function (sd) {
          var ls = lenses.filter(function (l) { return l.side === sd; }).sort(function (a, b) { return Math.abs(a.cx - W / 2) - Math.abs(b.cx - W / 2); });
          ls.forEach(function (a, i) {
            var ea = ext(a);
            if (sd * (a.cx - W / 2) < ea[0] + 24) a.cx = W / 2 + sd * (ea[0] + 24);   // never across the middle
            for (var j = 0; j < i; j++) {
              var b = ls[j], eb = ext(b);
              if (Math.abs(a.cy - b.cy) < ea[1] + eb[1] + GAP && Math.abs(a.cx - b.cx) < ea[0] + eb[0] + GAP) a.cx = b.cx + sd * (ea[0] + eb[0] + GAP);
            }
            a.cx = Math.max(40 + ea[0], Math.min(W - 40 - ea[0], a.cx));
          });
        });
      }
    }
    if (!deep) [['left', -1], ['right', 1]].forEach(function (sd) {
      var people = (order.ancestors || []).filter(function (a) { return a.side === sd[0] && a.name; }).slice(0, 2);
      var slots = [[560, 105], [1000, 175]];
      people.forEach(function (p, idx) {
        var nm = p.name.toUpperCase(), yr = p.years || '';
        var lhw = Math.max(capsLen(nm, 'root'), yr ? textW(yr, 'years') : 0) / 2 + 92;
        lenses.push({ side: sd[1], k: idx, cx: W / 2 + sd[1] * slots[idx][0], cy: by + slots[idx][1], hw: lhw, hh: yr ? 52 : 40,
                      tilt: sd[1] * 4.5 * Math.PI / 180, name: nm, years: yr, last: idx === people.length - 1 });
      });
    });
    var out = { scale: s, carts: carts, lenses: lenses, missing: missing, blankMissing: blankMissing, title: order.family ? 'The ' + order.family + ' Family' : '' };
    if (T.deep) { out.deep = true; out.deepv = T.v; out.gpS = gS; out.rf = RF; }
    return out;
  }
  function layout(order, T) {
    // largest lettering where every name and blank leaf fits; blank leaves never make names smaller than
    // 0.05 below the size the names alone need (then the ones that don't fit are reported in blankMissing)
    var tries = [1, 0.95, 0.9, 0.85, 0.8, 0.75, 0.7, 0.65], L = null, firstOk = null;
    for (var t = 0; t < tries.length; t++) {
      L = layoutAt(order, T, tries[t]);
      if (L.missing.length) continue;
      if (!L.blankMissing.length) return L;
      if (!firstOk) firstOk = L; else return firstOk;
    }
    return firstOk || L;
  }

  // ---------- shared geometry (same formulas as compose.py) ----------
  function framePath(cx, cy, hw, hh, seed) {
    var r = mulberry32(seed);
    var bumps = 5 + Math.floor(r() * 3), ph = r() * 6.28, amp = 0.05 + r() * 0.03;
    var a0 = r() * 2 * Math.PI, gap = 0.35 + r() * 0.25, pts = [];
    for (var i = 0; i < 220; i++) {
      var t = a0 + (2 * Math.PI - gap) * i / 219;
      var m = 1 + amp * Math.abs(Math.sin(bumps * (t - ph) / 2)) * 1.6 - amp * 0.6;
      pts.push([cx + Math.cos(t) * hw * m, cy + Math.sin(t) * hh * m]);
    }
    return pts;
  }
  function lensPts(L, upper, k) {
    k = k || 80; var out = [], ca = Math.cos(L.tilt), sa = Math.sin(L.tilt);
    for (var i = 0; i < k; i++) {
      var s = i / (k - 1), x = -L.hw + 2 * L.hw * s, y = (upper ? -1 : 1) * L.hh * Math.pow(Math.sin(Math.PI * s), 0.55);
      out.push([L.cx + x * ca - y * sa, L.cy + x * sa + y * ca]);
    }
    return out;
  }
  function bez(p0, p1, p2, p3, k) {
    var out = [];
    for (var i = 0; i < k; i++) {
      var t = i / (k - 1), u = 1 - t;
      out.push([u * u * u * p0[0] + 3 * u * u * t * p1[0] + 3 * u * t * t * p2[0] + t * t * t * p3[0],
                u * u * u * p0[1] + 3 * u * u * t * p1[1] + 3 * u * t * t * p2[1] + t * t * t * p3[1]]);
    }
    return out;
  }
  /* strokes for the ancestor roots: list of {pts, w0, w1, wood} ; leaves: [x, y, angle, len] */
  function rootStrokes(L, base_y) {
    var strokes = [], leaves = [];
    if (L.deep) {   // same formulas as compose.py
      L.lenses.forEach(function (l, j) {
        strokes.push({ pts: lensPts(l, true), w0: 3.6, w1: 2.8 }); strokes.push({ pts: lensPts(l, false), w0: 3.6, w1: 2.8 });
        var r = mulberry32(5000 + j), lo = lensPts(l, false);
        for (var q = 0; q < 2; q++) {
          var pt = lo[Math.floor(18 + r() * 44)], a = Math.atan2(1.0, (r() - 0.5) * 1.6), len = 30 + r() * 26, tw = [];
          for (var s = 0; s < 12; s++) tw.push([pt[0] + Math.cos(a) * len * s / 11 + 4 * Math.sin(s / 3) * (r() - 0.5), pt[1] + Math.sin(a) * len * s / 11]);
          strokes.push({ pts: tw, w0: 2.4, w1: 0.6 });
        }
      });
      return { strokes: strokes, leaves: leaves };
    }
    [-1, 1].forEach(function (side) {
      var ls = L.lenses.filter(function (l) { return l.side === side; });
      if (!ls.length) return;
      var prev = [W / 2 + side * 95, base_y - 30], prevW = 30;
      ls.forEach(function (l, idx) {
        var up = lensPts(l, true), inner = side > 0 ? up[0] : up[up.length - 1], outer = side > 0 ? up[up.length - 1] : up[0];
        var p1 = [prev[0] + side * 70, prev[1] + (idx === 0 ? 70 : 15)], p2 = [inner[0] - side * 140, inner[1] + 10];
        var path = bez(prev, p1, p2, inner, 70);
        strokes.push({ pts: path, w0: prevW, w1: 5.0, wood: prevW > 6 });
        strokes.push({ pts: up, w0: idx === 0 ? 5.5 : 4.2, w1: 3.2 });
        strokes.push({ pts: lensPts(l, false), w0: idx === 0 ? 5.5 : 4.2, w1: 3.2 });
        // two small rootlets hang from each name (roots have no leaves; same formulas as compose.py)
        var r = mulberry32(5000 + idx * 2 + (side > 0 ? 1 : 0)), lp = lensPts(l, false);
        for (var q = 0; q < 2; q++) {
          var pt = lp[14 + Math.floor(r() * 52)];
          var a = Math.atan2(1, (r() - 0.5) * 1.8), len = 26 + r() * 22, tw = [];
          for (var s = 0; s < 10; s++) tw.push([pt[0] + Math.cos(a) * len * s / 9, pt[1] + Math.sin(a) * len * s / 9]);
          strokes.push({ pts: tw, w0: 2.0, w1: 0.8 });
        }
        prev = outer; prevW = 3.4;
      });
      var ang = Math.atan2(0.18, side), tlen = Math.max(40, Math.min(190, side > 0 ? W - 60 - prev[0] : prev[0] - 60)), tail = [];
      for (var s = 0; s < 40; s++) { var d = tlen * s / 39; tail.push([prev[0] + Math.cos(ang) * d, prev[1] + Math.sin(ang) * d + 6 * Math.sin(d / 40)]); }
      strokes.push({ pts: tail, w0: 3.2, w1: 0.9 });
      var q0 = tail[14], fork = [];
      for (s = 0; s < 20; s++) fork.push([q0[0] + side * 90 * s / 19, q0[1] + 0.45 * 90 * s / 19]);
      strokes.push({ pts: fork, w0: 2.2, w1: 0.8 });
    });
    return { strokes: strokes, leaves: leaves };
  }
  function frameLeaves(cart, pts, seed) {
    var r = mulberry32(seed + 77), out = [], k = cart.kind === 'kid' ? 2 : 3;
    for (var i = 0; i < k; i++) {
      var q = pts[5 + Math.floor(r() * (pts.length - 10))];
      out.push([q[0], q[1], Math.atan2(q[1] - cart.y, q[0] - cart.x) + (r() - 0.5), 24 + r() * 14]);
    }
    return out;
  }
  function leafPoly(x, y, a, L) {
    var w = L * 0.36, pts = [], back = [];
    for (var i = 0; i < 12; i++) { var t = i / 11, r = Math.pow(Math.sin(Math.PI * t), 0.8) * (1 - 0.25 * t) * w / 2; pts.push([t * L, r]); back.unshift([t * L, -r]); }
    var ca = Math.cos(a), sa = Math.sin(a);
    return pts.concat(back).map(function (p) { return [x + p[0] * ca - p[1] * sa, y + p[0] * sa + p[1] * ca]; });
  }

  // ---------- preview drawing ----------
  var PAPER = 'rgb(250,247,238)', INK = 'rgb(40,45,60)', SOFT = 'rgb(88,94,110)', LINE = 'rgba(58,64,82,0.92)';
  function drawCaps(g, s, key, scale, cx, cy, k) {
    g.font = fontStr(key, scale * k); var x = cx - capsLen(s, key, scale) * k / 2;
    for (var i = 0; i < s.length; i++) { g.fillText(s[i], x, cy); x += (ctxFor().measureText(s[i]).width + TRACK * FONT[key][1] * scale) * k; }
  }
  function strokePath(g, pts, w0, w1, k, color) {
    g.strokeStyle = color; g.lineCap = 'round';
    for (var i = 0; i < pts.length - 1; i++) {
      var t = i / (pts.length - 1); g.lineWidth = Math.max(0.5, (w0 + (w1 - w0) * t) * k);
      g.beginPath(); g.moveTo(pts[i][0] * k, pts[i][1] * k); g.lineTo(pts[i + 1][0] * k, pts[i + 1][1] * k); g.stroke();
    }
  }
  function fillPoly(g, pts, k) { g.beginPath(); g.moveTo(pts[0][0] * k, pts[0][1] * k); for (var i = 1; i < pts.length; i++) g.lineTo(pts[i][0] * k, pts[i][1] * k); g.closePath(); g.fill(); }
  function draw(g, L, base, k, base_y) {
    g.drawImage(base, 0, 0, W * k, H * k);
    var roots = rootStrokes(L, base_y);
    // clear the paper inside every name space
    g.save(); g.filter = 'blur(' + (2.2 * k * 2) + 'px)'; g.fillStyle = PAPER;
    L.carts.forEach(function (c) { g.beginPath(); g.ellipse(c.x * k, c.y * k, c.hw * 0.98 * k, c.hh * 0.95 * k, 0, 0, 2 * Math.PI); g.fill(); });
    L.lenses.forEach(function (l) {
      var sh = { cx: l.cx, cy: l.cy, hw: l.hw * 0.97, hh: l.hh * 0.86, tilt: l.tilt };
      fillPoly(g, lensPts(sh, true).concat(lensPts(sh, false).reverse()), k);
    });
    g.restore();
    // twig frames
    g.save(); g.globalCompositeOperation = 'multiply';
    var leaves = roots.leaves.slice();
    L.carts.forEach(function (c, j) {
      var pts = framePath(c.x, c.y, c.hw, c.hh, 1000 + j), wmax = c.kind === 'gp' ? 4.4 : 3.3, m = pts.length;
      g.strokeStyle = LINE; g.lineCap = 'round';
      for (var a = 0; a < m - 1; a++) {
        var t = a / m; g.lineWidth = Math.max(0.6, wmax * (0.35 + 0.65 * Math.pow(Math.sin(Math.PI * Math.min(1, t * 1.15)), 0.6)) * k);
        g.beginPath(); g.moveTo(pts[a][0] * k, pts[a][1] * k); g.lineTo(pts[a + 1][0] * k, pts[a + 1][1] * k); g.stroke();
      }
      [[pts[0], pts[1], 1], [pts[m - 1], pts[m - 2], -1]].forEach(function (e) {
        var ang = Math.atan2(e[0][1] - e[1][1], e[0][0] - e[1][0]), px = e[0][0], py = e[0][1], curl = [[px, py]];
        for (var s = 1; s < 22; s++) { var th = ang + e[2] * s * 0.22, rr = 3.2 * (1 - s / 26); px += Math.cos(th) * rr * 2.2; py += Math.sin(th) * rr * 2.2; curl.push([px, py]); }
        strokePath(g, curl, 1.6, 1.4, k, LINE);
      });
      var fl = frameLeaves(c, pts, 1000 + j);
      if (L.deep && L.deepv >= 3 && c.kind === 'gp') fl = fl.filter(function (q) { return q[1] < c.y; });   // no leaves on the trunk under the couple
      leaves = leaves.concat(fl);
    });
    roots.strokes.forEach(function (st) { strokePath(g, st.pts, st.w0, st.w1, k, st.wood ? 'rgba(79,86,107,0.95)' : 'rgba(74,81,103,0.95)'); });
    g.fillStyle = 'rgba(169,178,147,0.85)';
    leaves.forEach(function (lf) { fillPoly(g, leafPoly(lf[0], lf[1], lf[2], lf[3]), k); });
    g.restore();
    // names
    g.save(); g.textBaseline = 'middle'; g.textAlign = 'left';
    L.carts.forEach(function (c) {
      g.fillStyle = INK;
      if (c.kind === 'kid' && !c.a) {   // blank leaf: a faint writing line
        g.strokeStyle = 'rgba(88,94,110,0.45)'; g.lineWidth = 1.4 * k; g.beginPath();
        g.moveTo((c.x - c.hw * 0.55) * k, (c.y + c.hh * 0.32) * k); g.lineTo((c.x + c.hw * 0.55) * k, (c.y + c.hh * 0.32) * k); g.stroke();
      } else if (c.kind === 'kid') drawCaps(g, c.a, 'kid', L.scale, c.x * k, c.y * k, k);
      else if (c.kind === 'couple') {
        var la = capsLen(c.a, 'couple', L.scale), lb = c.b ? capsLen(c.b, 'couple', L.scale) : 0, amp = c.b ? 62 * L.scale : 0, x0 = c.x - (la + lb + amp) / 2;
        drawCaps(g, c.a, 'couple', L.scale, (x0 + la / 2) * k, c.y * k, k);
        if (c.b) {
          g.fillStyle = SOFT; g.textAlign = 'center'; g.font = fontStr('ampS', L.scale * k); g.fillText('&', (x0 + la + amp / 2) * k, (c.y + 3) * k); g.textAlign = 'left';
          g.fillStyle = INK; drawCaps(g, c.b, 'couple', L.scale, (x0 + la + amp + lb / 2) * k, c.y * k, k);
        }
      } else {
        var gS = L.gpS || 1, la2 = capsLen(c.a, 'gp', gS), lb2 = capsLen(c.b, 'gp', gS), x1 = c.x - (la2 + lb2 + 120 * gS) / 2;
        drawCaps(g, c.a, 'gp', gS, (x1 + la2 / 2) * k, (c.y - 18 * gS) * k, k);
        g.fillStyle = SOFT; g.textAlign = 'center'; g.font = fontStr('amp', gS * k); g.fillText('&', (x1 + la2 + 60 * gS) * k, (c.y - 8 * gS) * k);
        if (c.year) { g.font = fontStr('small', gS * k); g.fillText('married ' + c.year, c.x * k, (c.y + 44 * gS) * k); }
        g.textAlign = 'left'; g.fillStyle = INK; drawCaps(g, c.b, 'gp', gS, (x1 + la2 + 120 * gS + lb2 / 2) * k, (c.y - 18 * gS) * k, k);
      }
    });
    var rf = L.rf || 1;
    L.lenses.forEach(function (l) {
      g.fillStyle = INK; drawCaps(g, l.name, 'root', rf, l.cx * k, (l.cy - (l.years ? 12 * rf : 0)) * k, k);
      if (l.years) { g.fillStyle = SOFT; g.textAlign = 'center'; g.font = fontStr('years', rf * k); g.fillText(l.years, l.cx * k, (l.cy + 22 * rf) * k); g.textAlign = 'left'; }
    });
    if (L.title) { g.fillStyle = INK; g.textAlign = 'center'; g.font = fontStr('title', k); g.fillText(L.title, W / 2 * k, 130 * k); }
    g.restore();
  }

  root.LegacyTree = { Tree: Tree, layout: layout, draw: draw, mulberry32: mulberry32, W: W, H: H };
})(window);
